import React, { Component } from "react";
import { ActionButton } from "../buttons";
import { Link } from "react-router-dom";
import { Wrapper, ConfirmationHeader, ConfirmationHeading } from "./style";
import Hook from "../../images/hookIcon";

export default class OrderSuccess extends Component {
  render() {
    const { invalidateOrder } = this.props;
    return (
      <Wrapper>
        <ConfirmationHeading>
          Ihre Bestellung war erfolgreich!
        </ConfirmationHeading>
        <ConfirmationHeader>
          <Hook width={150} height={100} />
        </ConfirmationHeader>
        <span>
          Vielen Dank für Ihre Bestellung. Wir werden uns zeitnah bei Ihnen
          melden.
        </span>
        <Link
          css={`
            width: 50%;
          `}
          to="/"
        >
          <ActionButton onClick={() => invalidateOrder()}>
            Zum Shop
          </ActionButton>
        </Link>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ../shop_main/components/order/success.js